/**
 * RESPONSIBILITY: one article of what the church believes.
 *
 * A heading and a paragraph, because that is the shape every statement of faith takes and
 * has taken for a very long time. Kept as ROWS rather than one block of prose so an
 * article can be reworded, reordered or added without retyping the rest — and so the page
 * can render them as a list somebody can scan.
 */
import { Row, Text, Paragraph, RenderOf } from '@framework/core/decorators';

@Row()
export class Article {
  @Text({ label: 'Heading', maxLength: 300, description: 'e.g. The Scriptures.' })
  title!: string;

  @Paragraph({
    label: 'What we believe', maxLength: 20000, rows: 4, markdown: true, allow: ['verse'],
  })
  body!: string;

  @RenderOf('body')
  bodyHtml!: string;
}
